/** The icon of each automation trigger, wherever a trigger is named. */
import {
  DateTimeIcon,
  EditIcon,
  PlayIcon,
  PlusIcon,
  SignalIcon,
} from '@blocksuite/icons/rc';
import type { TriggerType } from '@streamlain/automation-safety-contract';
import type { ReactElement, SVGAttributes } from 'react';

export const TRIGGER_ICONS: Record<
  TriggerType,
  ReactElement<SVGAttributes<SVGElement>>
> = {
  manual: <PlayIcon />,
  // Not the history's icon: the footer shows both side by side.
  scheduled: <DateTimeIcon />,
  row_created: <PlusIcon />,
  row_changed: <EditIcon />,
  webhook: <SignalIcon />,
};
